module.exports = __webpack_public_path__ + "static/media/background.c8dead68.png";